// extracted by mini-css-extract-plugin
module.exports = {"title":"guarantees_title__JB5XQ","container":"guarantees_container__mb1A8","text":"guarantees_text__J8GtV"};